The source system for the process history item.
